import {post} from '../../axiosconfig/axiosConfig'
import md5 from '../../common/md5'
import qs from 'qs'

export function login(params){
    var params = Object.assign({},params)
    params.password = md5.hexMD5(params.password).toUpperCase()
    // 登录地址与 civillan 保持一致，走 /api 代理（eastTrans 已补齐 /api 代理规则）
    return post('/api/project/user/login', qs.stringify(params))
}




// WEBPACK FOOTER //
// ./src/comm/api/userCenter/login.js